module.exports = __webpack_public_path__ + "static/img/企业等级.312609d8.png";